// extracted by mini-css-extract-plugin
module.exports = {"switch_container":"SwitchWithLabel_switch_container__2FTr_","switch_text":"SwitchWithLabel_switch_text__3ot-L"};